import { UseQueryResult, useQuery } from "@tanstack/react-query"

import { getGovtReport } from "../../../api/data"
import { UseQueryWithRefreshConfig } from "../utils/useQueryWithRefresh"
import { GovtApWizardType } from "@/types/govtAppWizard"

export function useGetGovtReport<TData extends BlobPart, TError>(
  accountId: string,
  values: GovtApWizardType,
  config: UseQueryWithRefreshConfig<TData, TError> = {}
): UseQueryResult<TData, TError> {
  return useQuery({
    queryKey: ["accounts", accountId, "govt_report", values],
    queryFn: async () => getGovtReport(accountId, values),
    ...config,
  })
}
